module.exports = __webpack_public_path__ + "static/sport/icon-3.e0edfe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/icon-3.png
// module id = Jesp
// module chunks = 0